import { Component, inject, input, output, signal } from '@angular/core';
import { AlertService } from '@context/frontend/alert';
import { UserRowComponent } from '@context/frontend/user';
import { Content } from '@context/shared/types/common';
import { User } from '@context/shared/types/user';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton } from '@taiga-ui/core';
import { TuiButtonLoading } from '@taiga-ui/kit';
import { DocumentReference } from 'firebase/firestore';
import { ContentService } from '../../../services';

@Component({
	imports: [UserRowComponent, TuiButton, TuiButtonLoading, TranslocoModule],
	selector: 'ctx-share-user-row',
	templateUrl: 'share-user-row.component.html',
	host: { class: 'contents' },
})
export class ShareUserRowComponent {
	readonly user = input.required<User>();

	readonly userRef = input.required<DocumentReference<User>>();

	readonly content = input.required<Content>();

	readonly remove = output<DocumentReference<User>>();

	readonly contentService = inject(ContentService);
	readonly alert = inject(AlertService);

	readonly busy = signal<boolean>(false);

	onRemove() {
		this.busy.set(true);
		return this.contentService
			.removeShareWithUser(this.content(), [this.userRef()])
			.then(() => {
				this.alert.open('generic-success').subscribe();
				this.remove.emit(this.userRef());
			})
			.catch((error) => {
				this.alert.open('generic-error').subscribe();
				console.error(error);
				throw new Error('There was an issue removing the shared user');
			})
			.finally(() => {
				this.busy.set(false);
			});
	}
}
